import { z } from 'zod';
import { SPORT_IDS } from '../sports';
import { getCityById } from '../geo/cities';

export const seoAcquisitionSchema = z.object({
  source: z.enum(['google', 'yandex', 'bing', 'duckduckgo', 'yahoo', 'baidu', 'other_search', 'referral', 'direct']),
  landingPath: z.string().max(240).regex(/^\/(?:[a-zA-Z0-9_/-]|%[0-9a-fA-F]{2})*$/).refine((path) => /^\/(?:$|gde-poigrat(?:\/|$)|clubs(?:\/[a-z0-9_-]+)?\/?$|balancer(?:\/|$))/.test(path), 'Public landing required'),
  city: z.string().max(80).refine((city) => !!getCityById(city), 'Unknown city').nullable(),
  sport: z.enum(SPORT_IDS as [string, ...string[]]).nullable(),
  capturedAt: z.string().datetime(),
}).strict();
export type SeoAcquisition = z.infer<typeof seoAcquisitionSchema>;
export interface SeoFunnel {
  playJourneys: SeoPlayJourney[];
  acquisition: SeoAcquisition | null;
  firstGamePlayed: { activityId: string; startedAt: string } | null;
  firstGameGoalClaimed: boolean;
}

export const seoJourneyParamsSchema = z.object({ requestId: z.string().uuid() }).strict();
export const seoJourneyClaimSchema = z.object({ stage: z.enum(['requested', 'joined', 'played']) }).strict();
export type SeoJourneyStage = z.infer<typeof seoJourneyClaimSchema>['stage'];
export interface SeoPlayJourney {
  requestId: string;
  city: string;
  sport: string;
  landingPath: string | null;
  requestedAt: string;
  requestedGoalClaimed: boolean;
  joinedGoalClaimed: boolean;
  playedGoalClaimed: boolean;
  joined: { activityId: string; signedUpAt: string } | null;
  played: { activityId: string; startedAt: string } | null;
}
